import { useData } from 'components/common-form/hooks/useData';
import { PayoffGraph, type PayoffGraphProps } from 'components/shared/Charts/PayoffGraph';

import type { ProductNodeBuilderProps } from '../ProductNodeBuilder.model';

export function JointLineScatterChartField({ node: { id } }: ProductNodeBuilderProps) {
  const [value] = useData<PayoffGraphProps>(id);

  return (
    <div className="w-100">
      <PayoffGraph axisNames={value?.axisNames} points={value?.points ?? []} />
    </div>
  );
}

JointLineScatterChartField.displayName = 'JointLineScatterChartField';
